// extracted by mini-css-extract-plugin
export var hidden = "_pr-1";
export var visible = "_pr-0";